<template>
  <div style="background-color: rgb(249, 249, 249);  width: 100%;">
    <div class="d-flex justify-center">
      <v-btn color="yellow darken-4" small text class="d-flex justify-center" @click="handleGetMainHeight">
        <v-icon size="30" color="yellow darken-4">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <div class="pt-16 pb-16">
      <YA_WriterContent1 />
    </div>
    <!-- <div class="pt-16 pb-16">
      <YA_Customers />
    </div> -->
  </div>
</template>

<script>
import YA_WriterContent1 from '@/components/PowerWriter/YA_WriterContent1.vue';

export default {
  name: 'PowerWriterContent',
  components: {
    YA_WriterContent1,
  },
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {

  },

  methods: {
    handleGetMainHeight() {
      this.$store.commit('HandlepowerWriterMainHeight', true);
    },
  }

};
</script>

<style scoped>

</style>